import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Header from '../components/header'
import ContentList6 from '../components/content-list6'
import FooterGray from '../components/footer-gray'
import './cgu.css'

const CGU = (props) => {
  return (
    <div className="cgu-container1">
      <Helmet>
        <title>CGU - Better Call AI</title>
        <meta
          name="description"
          content="La solution de gestion des appels client par l'intelligence artificielle.\nPrise en charge de votre agenda et prise de rendez-vous automatique."
        />
        <meta property="og:title" content="CGU - Better Call AI" />
        <meta
          property="og:description"
          content="La solution de gestion des appels client par l'intelligence artificielle.\nPrise en charge de votre agenda et prise de rendez-vous automatique."
        />
      </Helmet>
      <Header></Header>
      <div className="cgu-container2">
        <ContentList6
          content2={
            <Fragment>
              <span className="cgu-text10">
                <span>
                  Bienvenue sur BetterCallAI.fr. En accédant ou en utilisant
                  notre site, vous acceptez de respecter les présentes
                  Conditions Générales d&apos;Utilisation (CGU). Si vous êtes en
                  désaccord avec ces CGU, veuillez ne pas utiliser nos services.
                </span>
                <br></br>
                <span>
                  BetterCallAI est une plateforme fournissant des solutions
                  d&apos;intelligence artificielle dédiées au support client et
                  à l&apos;automatisation des tâches.
                </span>
              </span>
            </Fragment>
          }
          content3={
            <Fragment>
              <span className="cgu-text14">
                Lorem ipsum dolor sit amet. Est vitae blanditiis ab aliquam
                tempore aut ipsam iusto in sunt repellat ex voluptatum inventore
                ab facilis galisum ea consequatur consequuntur. Ab voluptas
                voluptatem eum consequatur aspernatur non laboriosam atque est
                labore asperiores a neque quos. Ea nemo modi hic dicta saepe et
                veritatis maiores At praesentium aliquid. Sed dolores architecto
                non doloribus quia eos consectetur commodi non tenetur vitae est
                neque omnis. Non perspiciatis velit At aliquam rerum ut officiis
                ipsa id minima eius ut sapiente nobis et nemo neque. Aut maiores
                tempora in officiis sunt eum voluptatem tenetur sit iste
                reprehenderit ea nisi dolor. Ea impedit omnis ad internos autem
                ut esse sunt ad saepe maiores vel perferendis veritatis. Ex
                magni fugiat ut reprehenderit laudantium sit galisum ipsam eos
                tempora doloribus sed accusantium nobis eum praesentium quod.
              </span>
            </Fragment>
          }
          content4={
            <Fragment>
              <span className="cgu-text15">
                Lorem ipsum dolor sit amet. Id galisum officiis rem quod
                internos qui provident quaerat hic minus eveniet est officiis
                galisum sit rerum dignissimos. Sit voluptatem alias et veniam
                rerum ea quod ipsam ut quam neque est nihil repellat est
                aspernatur voluptatem est voluptas ratione? Ea vero tempore At
                soluta temporibus 33 galisum excepturi quo modi distinctio. Qui
                dolor soluta sit ipsam vitae et suscipit molestiae est
                consequatur galisum aut sapiente voluptatem sed quas eaque et
                minima minus? Rem soluta consequatur et velit cupiditate sed
                eligendi laudantium rem pariatur galisum sit mollitia debitis
                eum delectus ipsum aut consequatur mollitia. Qui voluptatibus
                molestias ut totam Quis ea unde dolorem sit animi eveniet et
                galisum explicabo. Est culpa error ut voluptatibus voluptatem
                qui dignissimos dolorem quo laborum distinctio qui omnis
                perspiciatis ab facilis temporibus qui perspiciatis consectetur.
                Ab praesentium fugiat eos veritatis quam ex modi autem et
                sapiente dolorem?
              </span>
            </Fragment>
          }
          content5={
            <Fragment>
              <span className="cgu-text16">
                Lorem ipsum dolor sit amet. Ut cumque cupiditate eos perferendis
                tempora et ullam quis qui fugiat necessitatibus qui quia dolorem
                33 earum reprehenderit eum rerum blanditiis. Et vitae distinctio
                33 magni ratione ut odit rerum est nihil error et minus dolor
                quo harum fugiat. Eos quam assumenda id fugit optio aut magni
                sunt! Ut iure aliquam vel velit modi sit voluptatibus atque ut
                corporis sint sit omnis enim a pariatur officiis aut nulla
                voluptate. In facere incidunt aut sapiente maxime qui quibusdam
                facilis non officia consectetur sit laboriosam libero aut
                cupiditate possimus ut sunt reiciendis. Et repudiandae magnam
                aut quaerat ipsam aut repellat laboriosam. Ab facilis deleniti
                ut voluptas molestiae sed omnis maiores ut aliquid culpa vel
                nesciunt saepe. Aut placeat aspernatur aut alias nihil vel neque
                recusandae et corrupti accusantium ab quod temporibus ut nulla
                eaque et magnam nemo. Ad sunt minus rem earum delectus hic
                officia iste qui sunt quos non officiis illo vel doloribus
                perspiciatis. Ab soluta eius sed quidem dolores rem
                necessitatibus minus 33 minus commodi. Nam repudiandae libero
                non laboriosam voluptate et saepe fuga vel repudiandae pariatur
                aut assumenda illo.
              </span>
            </Fragment>
          }
          content6={
            <Fragment>
              <span className="cgu-text17">
                Ut doloremque aliquam qui veniam deserunt sit voluptates iusto
                et unde quod ut quam unde ut nemo eius! Ut saepe consequuntur
                non quibusdam soluta aut maiores eaque et rerum error nam
                incidunt saepe aut nihil voluptatem. 33 nulla quaerat est
                doloremque voluptatem ut libero magnam id placeat aliquid. Ea
                minus totam est inventore minus sed temporibus aperiam At
                ratione maiores eum libero consequatur aut laborum
                exercitationem.
              </span>
            </Fragment>
          }
          content9={
            <Fragment>
              <span className="cgu-text18">
                <span>
                  Le site BetterCallAI.fr est édité par : Nom de l’entreprise :
                  FB Prestas 
                </span>
                <br></br>
                <span>
                  Siège social : 46 rue de l’aulnaie, 27120 Fontaine-sous-jouy
                   SIRET : 95185254000016 Contact :
                  florian.breton11+bca@gmail.com 
                </span>
                <br></br>
                <span>Directeur de la publication : Mr Breton</span>
                <br></br>
                <span>
                  L’hébergement du site est assuré par : Nom de l’hébergeur : FB
                  Prestas  Contact : florian.breton11+bca@gmail.com
                </span>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="cgu-text26">Privacy statement</span>
            </Fragment>
          }
          heading2={
            <Fragment>
              <span className="cgu-text27">Types of data we collect</span>
            </Fragment>
          }
          heading3={
            <Fragment>
              <span className="cgu-text28">How we use your data</span>
            </Fragment>
          }
          heading4={
            <Fragment>
              <span className="cgu-text29">
                Sharing your data with 3rd parties
              </span>
            </Fragment>
          }
          heading5={
            <Fragment>
              <span className="cgu-text30">Campaign tracking</span>
            </Fragment>
          }
          heading6={
            <Fragment>
              <span className="cgu-text31">Cookies</span>
            </Fragment>
          }
          heading7={
            <Fragment>
              <span className="cgu-text32">
                Conditions générales d&apos;Utilisation
              </span>
            </Fragment>
          }
          heading8={
            <Fragment>
              <span className="cgu-text33">Introduction</span>
            </Fragment>
          }
          heading9={
            <Fragment>
              <span className="cgu-text34">Mentions Légales</span>
            </Fragment>
          }
          content10={
            <Fragment>
              <span className="cgu-text35">
                Lorem ipsum dolor sit amet. Vel dolores illum est aperiam quis
                nam voluptatem quia et omnis autem qui dolore ullam sed fugiat
                cumque! Qui accusamus assumenda et molestias eius et error sunt.
                Id recusandae nostrum ea officiis voluptatem in nisi consequatur
                sed quia tenetur sit alias molestias qui illum soluta. Est
                nesciunt perferendis eum sint rerum 33 cupiditate dolorem id
                corrupti laboriosam ut debitis veniam ut ipsam fugit vel sunt
                consequatur. Et nobis quasi et cumque adipisci aut molestiae
                eligendi quo inventore dicta ea suscipit sequi sed veritatis
                nemo.
              </span>
            </Fragment>
          }
          content11={
            <Fragment>
              <span className="cgu-text36">
                Lorem ipsum dolor sit amet. Nam nihil facilis sit consequuntur
                internos qui minima rerum ut molestias laudantium aut iusto
                deserunt. Aut voluptatibus excepturi qui officia laudantium est
                repellendus tempore hic sunt debitis. Ut galisum tempore in enim
                fugit eum pariatur possimus est tenetur nemo et sint sint et
                dolores Quis. Aut illum perspiciatis rem architecto culpa et
                fuga aliquid. Est omnis praesentium ut nisi internos rem quod
                totam et similique quis. Est tempore cumque aut recusandae
                labore qui error molestiae et possimus quia! Eum Quis asperiores
                non nihil tempora qui quia voluptatem aut aspernatur aspernatur
                aut asperiores labore et sapiente quaerat qui suscipit quia. Ea
                nesciunt iste aut temporibus culpa sit dignissimos quaerat eum
                architecto voluptatum et nemo velit At harum harum.
              </span>
            </Fragment>
          }
          content12={
            <Fragment>
              <span className="cgu-text37">
                Lorem ipsum dolor sit amet. Est vitae blanditiis ab aliquam
                tempore aut ipsam iusto in sunt repellat ex voluptatum inventore
                ab facilis galisum ea consequatur consequuntur. Ab voluptas
                voluptatem eum consequatur aspernatur non laboriosam atque est
                labore asperiores a neque quos. Ea nemo modi hic dicta saepe et
                veritatis maiores At praesentium aliquid. Sed dolores architecto
                non doloribus quia eos consectetur commodi non tenetur vitae est
                neque omnis. Non perspiciatis velit At aliquam rerum ut officiis
                ipsa id minima eius ut sapiente nobis et nemo neque. Aut maiores
                tempora in officiis sunt eum voluptatem tenetur sit iste
                reprehenderit ea nisi dolor. Ea impedit omnis ad internos autem
                ut esse sunt ad saepe maiores vel perferendis veritatis. Ex
                magni fugiat ut reprehenderit laudantium sit galisum ipsam eos
                tempora doloribus sed accusantium nobis eum praesentium quod.
              </span>
            </Fragment>
          }
          content13={
            <Fragment>
              <span className="cgu-text38">
                Lorem ipsum dolor sit amet. Est vitae blanditiis ab aliquam
                tempore aut ipsam iusto in sunt repellat ex voluptatum inventore
                ab facilis galisum ea consequatur consequuntur. Ab voluptas
                voluptatem eum consequatur aspernatur non laboriosam atque est
                labore asperiores a neque quos. Ea nemo modi hic dicta saepe et
                veritatis maiores At praesentium aliquid. Sed dolores architecto
                non doloribus quia eos consectetur commodi non tenetur vitae est
                neque omnis. Non perspiciatis velit At aliquam rerum ut officiis
                ipsa id minima eius ut sapiente nobis et nemo neque. Aut maiores
                tempora in officiis sunt eum voluptatem tenetur sit iste
                reprehenderit ea nisi dolor. Ea impedit omnis ad internos autem
                ut esse sunt ad saepe maiores vel perferendis veritatis. Ex
                magni fugiat ut reprehenderit laudantium sit galisum ipsam eos
                tempora doloribus sed accusantium nobis eum praesentium quod.
              </span>
            </Fragment>
          }
          content91={
            <Fragment>
              <span className="cgu-text39">
                <span>
                  Le site est accessible gratuitement à tout utilisateur
                  disposant d’un accès à Internet. L’utilisateur est responsable
                  de son matériel informatique et de sa connexion pour accéder
                  au site. Certaines fonctionnalités peuvent nécessiter une
                  inscription ou un abonnement.
                </span>
                <br></br>
                <span>
                  Nous nous réservons le droit de restreindre, suspendre ou
                  modifier l’accès à tout ou partie du site sans préavis,
                  notamment pour des raisons de maintenance.
                </span>
              </span>
            </Fragment>
          }
          heading10={
            <Fragment>
              <span className="cgu-text43">Refund Policy</span>
            </Fragment>
          }
          heading11={
            <Fragment>
              <span className="cgu-text44">General</span>
            </Fragment>
          }
          heading12={
            <Fragment>
              <span className="cgu-text45">Damages and issues</span>
            </Fragment>
          }
          heading13={
            <Fragment>
              <span className="cgu-text46">Refunds</span>
            </Fragment>
          }
          heading91={
            <Fragment>
              <span className="cgu-text47">Accès au site</span>
            </Fragment>
          }
          content911={
            <Fragment>
              <span className="cgu-text48">
                <span>
                  BetterCallAI offre des solutions basées sur
                  l&apos;intelligence artificielle pour optimiser les processus
                  d&apos;entreprise et améliorer les interactions avec les
                  clients.
                </span>
                <br></br>
                <span>
                  Ces services sont susceptibles d’évoluer ou d’être modifiés à
                  tout moment.
                </span>
              </span>
            </Fragment>
          }
          heading911={
            <Fragment>
              <span className="cgu-text52">Services proposés</span>
            </Fragment>
          }
          content9111={
            <Fragment>
              <span className="cgu-text53">
                Tous les contenus présents sur le site (textes, images, vidéos,
                logos, codes, etc.) sont protégés par la législation française
                et internationale relative à la propriété intellectuelle. Toute
                reproduction, représentation, modification, ou exploitation,
                partielle ou totale, sans autorisation écrite préalable, est
                strictement interdite.
              </span>
            </Fragment>
          }
          heading9111={
            <Fragment>
              <span className="cgu-text54">Propriété intellectuelle</span>
            </Fragment>
          }
          content91111={
            <Fragment>
              <span className="cgu-text55">
                <span>
                  Certaines fonctionnalités nécessitent la création d’un compte
                  utilisateur. En créant un compte, vous acceptez de fournir des
                  informations exactes et à jour.
                </span>
                <br></br>
                <span>
                  Vous êtes seul responsable de la confidentialité de vos
                  identifiants.
                </span>
                <br></br>
                <span>
                  En cas d&apos;utilisation non autorisée de votre compte,
                  veuillez nous en informer immédiatement.
                </span>
                <br></br>
                <span>
                  Nous nous réservons le droit de suspendre ou de supprimer tout
                  compte en cas de violation des présentes CGU.
                </span>
              </span>
            </Fragment>
          }
          heading91111={
            <Fragment>
              <span className="cgu-text63">
                Inscription et comptes utilisateurs
              </span>
            </Fragment>
          }
          content911111={
            <Fragment>
              <span className="cgu-text64">
                <span>
                  L’utilisateur s’engage à utiliser le site conformément aux
                  lois en vigueur et à ne pas :
                </span>
                <br></br>
                <span>
                  Publier ou transmettre des contenus illégaux, injurieux ou
                  diffamatoires.
                </span>
                <br></br>
                <span>
                  Tenter d’accéder à des parties non autorisées du site.
                </span>
                <br></br>
                <span>
                  Provoquer des interférences ou perturber le fonctionnement du
                  site.
                </span>
              </span>
            </Fragment>
          }
          heading911111={
            <Fragment>
              <span className="cgu-text72">
                Responsabilité de l&apos;utilisateur
              </span>
            </Fragment>
          }
          content9111111={
            <Fragment>
              <span className="cgu-text73">
                Lorem ipsum dolor sit amet. Est vitae blanditiis ab aliquam
                tempore aut ipsam iusto in sunt repellat ex voluptatum inventore
                ab facilis galisum ea consequatur consequuntur. Ab voluptas
                voluptatem eum consequatur aspernatur non laboriosam atque est
                labore asperiores a neque quos. Ea nemo modi hic dicta saepe et
                veritatis maiores At praesentium aliquid. Sed dolores architecto
                non doloribus quia eos consectetur commodi non tenetur vitae est
                neque omnis. Non perspiciatis velit At aliquam rerum ut officiis
                ipsa id minima eius ut sapiente nobis et nemo neque. Aut maiores
                tempora in officiis sunt eum voluptatem tenetur sit iste
                reprehenderit ea nisi dolor. Ea impedit omnis ad internos autem
                ut esse sunt ad saepe maiores vel perferendis veritatis. Ex
                magni fugiat ut reprehenderit laudantium sit galisum ipsam eos
                tempora doloribus sed accusantium nobis eum praesentium quod.
              </span>
            </Fragment>
          }
          heading9111111={
            <Fragment>
              <span className="cgu-text74">Responsabilité de BetterCallAI</span>
            </Fragment>
          }
          content91111111={
            <Fragment>
              <span className="cgu-text75">
                L’utilisation de vos données personnelles est régie par notre
                Politique de Confidentialité. Nous nous engageons à protéger vos
                informations conformément au Règlement Général sur la Protection
                des Données (RGPD).
              </span>
            </Fragment>
          }
          heading91111111={
            <Fragment>
              <span className="cgu-text76">Données personnelles</span>
            </Fragment>
          }
          content911111111={
            <Fragment>
              <span className="cgu-text77">
                <span>
                  Le site peut contenir des liens vers des sites tiers. Nous ne
                  sommes pas responsables des contenus, politiques ou pratiques
                  de ces sites.
                </span>
                <br></br>
              </span>
            </Fragment>
          }
          heading911111111={
            <Fragment>
              <span className="cgu-text80">Liens externes</span>
            </Fragment>
          }
          content9111111111={
            <Fragment>
              <span className="cgu-text81">
                Nous nous réservons le droit de modifier ces CGU à tout moment.
                Les modifications seront publiées sur cette page, et il est de
                votre responsabilité de consulter régulièrement les mises à
                jour.
              </span>
            </Fragment>
          }
          heading9111111111={
            <Fragment>
              <span className="cgu-text82">Modification des CGU</span>
            </Fragment>
          }
          content91111111111={
            <Fragment>
              <span className="cgu-text83">
                Les présentes CGU sont régies par la loi française. En cas de
                litige, les tribunaux compétents seront ceux de France.
              </span>
            </Fragment>
          }
          heading91111111111={
            <Fragment>
              <span className="cgu-text84">
                Droit applicable et juridiction
              </span>
            </Fragment>
          }
        ></ContentList6>
      </div>
      <FooterGray></FooterGray>
    </div>
  )
}

export default CGU
